import fetch from '@/utils/fetch';

// 内部应用通过临时授权码获取用户信息和用户角色
export function getUserListByCode(_param) {
  return fetch({
    url: '/dsapi/sst/yonghu-info/getUserListByCode',
    method: 'post',
    params: _param,
  });
}
// 绑定师生通钉钉用户编码
export function bindDingTalkUserId(_param) {
  return fetch({
    url: '/dsapi/relative/ding-sst-user/bindDingTalkUserId',
    method: 'get',
    params: _param,
  });
}
// 绑定师生通钉钉用户编码
export function unbindDingTalkUserId(_param) {
  return fetch({
    url: '/dsapi/relative/ding-sst-user/unbindDingTalkUserId',
    method: 'get',
    params: _param,
  });
}
// 角色绑定
export function selectBindUser(_param) {
  return fetch({
    url: '/dsapi/sst/yonghu-info/selectBindUser',
    method: 'post',
    params: _param,
  });
}
